import i18next from 'i18next';
import ClipboardJS from 'clipboard';
import Message from '@/component/Message';
// 复制粘贴功能
const clipboard: any = new ClipboardJS('.xcodeblock_cope_svg');
clipboard.on('success', () => {
  Message.info(i18next.t('copy_success'));
});
const clipboardLink: any = new ClipboardJS('.copy-link');
clipboardLink.on('success', () => {
  Message.info(i18next.t('copy_success'));
});
